import { useMutation } from 'react-query';
import { getWorkerExistsByEmail } from 'shared/services/worker-service';
import { GetWorkerExistsByEmailParams } from 'shared/services/worker-service.types';

export const useWorkerExistsByEmail = (verified: boolean) => {
  return useMutation<boolean, Error, GetWorkerExistsByEmailParams>({
    mutationFn: (params) => getWorkerExistsByEmail({ ...params, verified }),
  });
};
